var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklistWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_195_7664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9994 4.015C10.9994 3.74 10.7744 3.515 10.4994 3.515H6.99937C6.72437 3.515 6.49937 3.74 6.49937 4.015C6.49937 4.29 6.72437 4.515 6.99937 4.515H10.4994C10.7744 4.515 10.9994 4.29 10.9994 4.015ZM6.49937 8.015C6.49937 8.29 6.72437 8.515 6.99937 8.515H10.4994C10.7744 8.515 10.9994 8.29 10.9994 8.015C10.9994 7.74 10.7744 7.515 10.4994 7.515H6.99937C6.72437 7.515 6.49937 7.74 6.49937 8.015ZM5.23438 2.33C5.42937 2.525 5.42937 2.84 5.23438 3.035L3.11937 5.16C2.92437 5.355 2.60938 5.355 2.40938 5.16L1.34937 4.095C1.15438 3.9 1.15438 3.585 1.34937 3.39C1.54437 3.195 1.85938 3.195 2.05438 3.39L2.76438 4.1L4.53437 2.33C4.72437 2.14 5.04438 2.14 5.23438 2.33ZM5.23937 6.335C5.43437 6.53 5.43437 6.845 5.23937 7.04L3.12437 9.165C2.92937 9.36 2.61437 9.36 2.41437 9.165L1.34937 8.095C1.15438 7.9 1.15438 7.585 1.34937 7.39C1.54437 7.195 1.85938 7.195 2.05438 7.39L2.76438 8.1L4.53437 6.33C4.72437 6.14 5.04437 6.14 5.23937 6.335Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_195_7664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0 0.015625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklistWhite);
export default __webpack_public_path__ + "static/media/ChecklistWhite.f889e26b5fe4f05300c53a8bd10e644c.svg";
export { ForwardRef as ReactComponent };